import { render, staticRenderFns } from "./physioPowerEdit.vue?vue&type=template&id=1805004d&scoped=true"
import script from "./physioPowerEdit.vue?vue&type=script&lang=js"
export * from "./physioPowerEdit.vue?vue&type=script&lang=js"
import style0 from "./physioPowerEdit.vue?vue&type=style&index=0&id=1805004d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1805004d",
  null
  
)

export default component.exports